import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const HTopbar = ({ scrollDelay = 50 }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const isHomePage = location.pathname === '/';
  const isLoginPage = location.pathname === '/login';
  const isRegisterPage = location.pathname === '/register';
  const isForgotPasswordPage = location.pathname === '/recover';

  const showNavigationLinks = isHomePage || isLoginPage || isRegisterPage || isForgotPasswordPage;

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleScrollLink = (e, sectionId) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      // Navigate to home, then scroll after slight delay
      navigate(`/#${sectionId}`);
      setTimeout(() => {
        const el = document.getElementById(sectionId);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, scrollDelay);
    } else {
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
    setIsOpen(false); // close menu on mobile
  };

  return (
    <nav
      className="navbar navbar-expand-lg navbar-light shadow fixed-top"
      style={{
        zIndex: 1000,
        background: 'linear-gradient(90deg, #E51110 19%, #F08400 50%, #FFF049 76%)',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        height: '56px',
      }}
    >
      <div className="container-fluid px-4 h-100 d-flex align-items-center">
        {/* Logo */}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            if (location.pathname !== '/') {
              navigate('/');
            } else {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }}
          className="navbar-brand fw-bold text-dark"
        >
          <img
            src="/images/logo.jpg"
            alt="Logo"
            className="img-fluid"
            style={{ height: '40px', objectFit: 'cover' }}
          />
        </a>

        {/* Hamburger */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu}
          aria-controls="navbarNav"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible menu */}
        <div
          className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`}
          id="navbarNav"
          style={{
            background: 'linear-gradient(90deg, #E51110 19%, #F08400 50%, #FFF049 76%)',
          }}
        >          <ul className="navbar-nav ms-auto align-items-center gap-3 fw-bold">
            {showNavigationLinks && (
              <>
                <li className="nav-item">
                  <a
                    href="#how-it-works"
                    className="nav-link text-dark"
                    onClick={(e) => handleScrollLink(e, 'how-it-works')}
                  >
                    How It Works
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="#why-matchup"
                    className="nav-link text-dark"
                    onClick={(e) => handleScrollLink(e, 'why-matchup')}
                  >
                    Why MatchUp
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="#featured-sports"
                    className="nav-link text-dark"
                    onClick={(e) => handleScrollLink(e, 'featured-sports')}
                  >
                    Featured Sports
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="#testimonials"
                    className="nav-link text-dark"
                    onClick={(e) => handleScrollLink(e, 'testimonials')}
                  >
                    Testimonials
                  </a>
                </li>
              </>
            )}
            <li className="nav-item">
              <Link to="/login" className="nav-link text-dark">Log in</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default HTopbar;
